export default "__VITE_ASSET__DBYJyFtx__"